import { render, staticRenderFns } from "./EmployeesPage.vue?vue&type=template&id=f64a1742&scoped=true"
import script from "./EmployeesPage.vue?vue&type=script&lang=js"
export * from "./EmployeesPage.vue?vue&type=script&lang=js"
import style0 from "./EmployeesPage.vue?vue&type=style&index=0&id=f64a1742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64a1742",
  null
  
)

export default component.exports